import datePicker from './datePicker';
import hidden from './hidden';
import input from './input';
import slider from './slider';
import iswitch from './switch';
import row from './row';

export default [
    datePicker, hidden, input, slider, iswitch, row
]
